

function getGreekLetters(...a) {
  return [...Array(24)].map((_, i) =>
    String.fromCharCode(i * 1.06 + 913 + 32 * a.length)
  );
}

export const lists = {
  alpha: {
    group_title: "Alpha",
    group_description: "",
    group_lists: {
      english_letters_lower: {
        title: "English - lower case",
        button_text: "",
        demo: "a, b, c",
        content: [
          "a",
          "b",
          "c",
          "d",
          "e",
          "f",
          "g",
          "h",
          "i",
          "j",
          "k",
          "l",
          "m",
          "n",
          "o",
          "p",
          "q",
          "r",
          "s",
          "t",
          "u",
          "v",
          "w",
          "x",
          "y",
          "z",
        ],
      },
      english_letters_upper: {
        title: "English - UPPER CASE",
        button_text: "",
        demo: "A, B, C",
        content: [
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z",
        ],
      },
      greekLetters: {
        content: getGreekLetters(),
        title: "Greek letters",
        button_text: "",
        demo: getGreekLetters(0),
      },
    },
  },
  // numeric: { group_title: "Numeric", group_description: "", group_lists: {} },
  time: {
    group_title: "Time",
    group_description: "",
    group_lists: {
      twelveHourClock: {
        title: "24 Hours in the Day (12 hour)",
        button_text: "",
        demo: "12:00am, 1:00am, 2:00am",
        content: [
          "12:00am",
          "1:00am",
          "2:00am",
          "3:00am",
          "4:00am",
          "5:00am",
          "6:00am",
          "7:00am",
          "8:00am",
          "9:00am",
          "10:00am",
          "11:00am",
          "12:00pm",
          "1:00pm",
          "2:00pm",
          "3:00pm",
          "4:00pm",
          "5:00pm",
          "6:00pm",
          "7:00pm",
          "8:00pm",
          "9:00pm",
          "10:00pm",
          "11:00pm",
        ],
      },
      twenty_four_hour_clock: {
        title: "24 Hours in the Day (24 hour)",
        button_text: "",
        demo: "00:00, 01:00, 02:00",
        content: [
          "1:00",
          "2:00",
          "3:00",
          "4:00",
          "5:00",
          "6:00",
          "7:00",
          "8:00",
          "9:00",
          "10:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
      },
      daysOfWeek_firstCap: {
        title: "Days of the Week: full",
        button_text: "",
        demo: "Sunday, Monday . . .",
        content: [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ],
      },
      daysOfWeek_allCap: {
        title: "Days of the Week",
        button_text: "",
        demo: "SUNDAY, MONDAY . . .",
        content: [
          "SUNDAY",
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
          "SATURDAY",
        ],
      },
      daysOfWeek_lowerCase_abbr: {
        title: "Days of the Week",
        button_text: "",
        demo: "sun, mon, . . .",
        content: ["sun", "mon", "tues", "wed", "thu", "fri", "sat"],
      },
      daysOfWeek_allCap_abbr: {
        title: "Days of the Week",
        button_text: "",
        demo: "SUN, MON . . . ",
        content: ["SUN", "MON", "TUES", "WED", "THUR", "FRI", "SAT"],
      },

      months_firstCaps: {
        title: "Months of the Year",
        button_text: "",
        demo: "January, February . . .",
        content: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
      },
      months_firstCaps_abbr: {
        title: "Months of Year - abbrv.",
        button_text: "",
        demo: "Jan, Feb . . .",
        content: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "July",
          "Aug",
          "Sept",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      months_firstCaps_abbr_caps: {
        title: "Months of Year - CAPS abbrv.",
        button_text: "",
        demo: "JAN, FEB . . .",
        content: [
          "JAN",
          "FEB",
          "MAR",
          "APR",
          "MAY",
          "JUN",
          "JULY",
          "AUG",
          "SEPT",
          "OCT",
          "NOV",
          "DEC",
        ],
      },
      months_first_letter: {
        title: "Months of Year - First Letter",
        button_text: "",
        demo: "J, F, M . . .",
        content: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      },
      zodiac_text: {
        title: "Signs of the Zodiac",
        button_text: "",
        demo: "Aquarius, Pisces . . .",
        content: [
          "Aquarius",
          "Pisces",
          "Aries",
          "Taurus",
          "Gemini",
          "Cancer",
          "Leo",
          "Virgo",
          "Libra",
          "Scorpio",
          "Sagittarius",
          "Capricorn",
        ],
      },
      zodiac_emoji: {
        title: "Signs of the Zodiac",
        button_text: "",
        demo: "♒, ♓ . . .",
        content: [
          "♒",
          "♓",
          "♈",
          "♉",
          "♊",
          "♋",
          "♌",
          "♍",
          "♎",
          "♏",
          "♐",
          "♑",
        ],
      },
    },
  },
  nature_science: {
    group_title: "Nature & Science",
    group_description: "",
    group_lists: {
      squirrels: {
        title: "Squirrels",
        button_text: "",
        demo: "Squirrel types, 🐿️😂",
        content: [
          "Fox",
          "Eastern Grey",
          "Western Grey",
          "Abert's",
          "Southern Fox",
          "American Red",
          "European Red",
          "Douglas",
          "Palm",
          "Prevost's",
          "Delmarva Fox",
        ],
      },
      planets_in_our_solar_system: {
        title: "Planets in our Solar System",
        button_text: "",
        demo: "Mercury, Venus . . .",
        content: [
          "Mercury",
          "Venus",
          "Earth",
          "Mars",
          "Jupiter",
          "Saturn",
          "Uranus",
          "Pluto (dwarf)",
          "Eris (dwarf)",
          "Makemake (dwarf)",
          "Haumea (dwarf)",
          "Ceres (dwarf)",
        ],
      },
      elements_full_name: {
        title: "Elements - full name",
        button_text: "",
        demo: "Hydrogen, Helium . . .",
        content: [
          "Hydrogen",
          "Helium",
          "Lithium",
          "Beryllium",
          "Boron",
          "Carbon",
          "Nitrogen",
          "Oxygen",
          "Fluorine",
          "Neon",
          "Miro-nium",
          "Sodium",
          "Magnesium",
          "Aluminium",
          "Silicon",
          "Phosphorus",
          "Sulfur",
          "Chlorine",
          "Argon",
          "Potassium",
          "Calcium",
          "Scandium",
          "Titanium",
          "Vanadium",
          "Chromium",
          "Manganese",
          "Iron",
          "Cobalt",
          "Nickel",
          "Copper",
          "Zinc",
          "Gallium",
          "Germanium",
          "Arsenic",
          "Selenium",
          "Bromine",
          "Krypton",
          "Rubidium",
          "Strontium",
          "Yttrium",
          "Zirconium",
          "Niobium",
          "Molybdenum",
          "Technetium",
          "Ruthenium",
          "Rhodium",
          "Palladium",
          "Silver",
          "Cadmium",
          "Indium",
          "Tin",
          "Antimony",
          "Tellurium",
          "Iodine",
          "Xenon",
          "Caesium",
          "Barium",
          "Lanthanum",
          "Cerium",
          "Praseodymium",
          "Neodymium",
          "Promethium",
          "Samarium",
          "Europium",
          "Gadolinium",
          "Terbium",
          "Dysprosium",
          "Holmium",
          "Erbium",
          "Thulium",
          "Ytterbium",
          "Lutetium",
          "Hafnium",
          "Tantalum",
          "Tungsten",
          "Rhenium",
          "Osmium",
          "Iridium",
          "Platinum",
          "Gold",
          "Mercury",
          "Thallium",
          "Lead",
          "Bismuth",
          "Polonium",
          "Astatine",
          "Radon",
          "Francium",
          "Radium",
          "Actinium",
          "Thorium",
          "Protactinium",
          "Uranium",
          "Neptunium",
          "Plutonium",
          "Americium",
          "Curium",
          "Berkelium",
          "Californium",
          "Einsteinium",
          "Fermium",
          "Mendelevium",
          "Nobelium",
          "Lawrencium",
          "Rutherfordium",
          "Dubnium",
          "Seaborgium",
          "Bohrium",
          "Hassium",
          "Meitnerium",
          "Darmstadtium",
          "Roentgenium",
          "Copernicium",
          "Nihonium",
          "Flerovium",
          "Moscovium",
          "Livermorium",
          "Tennessine",
          "Oganesson",
        ],
      },
      elements_first_letter: {
        title: "Elements - first letter",
        button_text: "",
        demo: "H, HE, LI, ",
        content: [
          "H",
          "He",
          "Li",
          "Be",
          "B",
          "C",
          "N",
          "O",
          "F",
          "Ne",
          "Na",
          "Mg",
          "Al",
          "Si",
          "P",
          "S",
          "Cl",
          "Ar",
          "K",
          "Ca",
          "Sc",
          "Ti",
          "V",
          "Cr",
          "Mn",
          "Fe",
          "Co",
          "Ni",
          "Cu",
          "Zn",
          "Ga",
          "Ge",
          "As",
          "Se",
          "Br",
          "Kr",
          "Rb",
          "Sr",
          "Y",
          "Zr",
          "Nb",
          "Mo",
          "Tc",
          "Ru",
          "Rh",
          "Pd",
          "Ag",
          "Cd",
          "In",
          "Sn",
          "Sb",
          "Te",
          "I",
          "Xe",
          "Cs",
          "Ba",
          "La",
          "Ce",
          "Pr",
          "Nd",
          "Pm",
          "Sm",
          "Eu",
          "Gd",
          "Tb",
          "Dy",
          "Ho",
          "Er",
          "Tm",
          "Yb",
          "Lu",
          "Hf",
          "Ta",
          "W",
          "Re",
          "Os",
          "Ir",
          "Pt",
          "Au",
          "Hg",
          "Tl",
          "Pb",
          "Bi",
          "Po",
          "At",
          "Rn",
          "Fr",
          "Ra",
          "Ac",
          "Th",
          "Pa",
          "U",
          "Np",
          "Pu",
          "Am",
          "Cm",
          "Bk",
          "Cf",
          "Es",
          "Fm",
          "Md",
          "No",
          "Lr",
          "Rf",
          "Db",
          "Sg",
          "Bh",
          "Hs",
          "Mt",
          "Ds",
          "Rg",
          "Cn",
          "Nh",
          "Fl",
          "Mc",
          "Lv",
          "Ts",
          "Og",
        ],
      },
    },
  },
  numbers: {
    group_title: "Numeric",
    group_description: "",
    group_lists: {
      integersLessThanEqualTo100: {
        title: "Integers <= 100",
        button_text: "",
        demo: "1,2,3,4,5",
        content: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31",
          "32",
          "33",
          "34",
          "35",
          "36",
          "37",
          "38",
          "39",
          "40",
          "41",
          "42",
          "43",
          "44",
          "45",
          "46",
          "47",
          "48",
          "49",
          "50",
          "51",
          "52",
          "53",
          "54",
          "55",
          "56",
          "57",
          "58",
          "59",
          "60",
          "61",
          "62",
          "63",
          "64",
          "65",
          "66",
          "67",
          "68",
          "69",
          "70",
          "71",
          "72",
          "73",
          "74",
          "75",
          "76",
          "77",
          "78",
          "79",
          "80",
          "81",
          "82",
          "83",
          "84",
          "85",
          "86",
          "87",
          "88",
          "89",
          "90",
          "91",
          "92",
          "93",
          "94",
          "95",
          "96",
          "97",
          "98",
          "99",
          "100",
        ],
      },
      evensLessThan100: {
        title: "Evens < 100",
        button_text: "",
        demo: "2,4,6,8,10",
        content: [
          "2",
          "4",
          "6",
          "8",
          "10",
          "12",
          "14",
          "16",
          "18",
          "20",
          "22",
          "24",
          "26",
          "28",
          "30",
          "32",
          "34",
          "36",
          "38",
          "40",
          "42",
          "44",
          "46",
          "48",
          "50",
          "52",
          "54",
          "56",
          "58",
          "60",
          "62",
          "64",
          "66",
          "68",
          "70",
          "72",
          "74",
          "76",
          "78",
          "80",
          "82",
          "84",
          "86",
          "88",
          "90",
          "92",
          "94",
          "96",
          "98",
          "100",
        ],
      },
      oddsLessThan100: {
        title: "Odds < 100",
        button_text: "",
        demo: "1,3,5,7,9",
        content: [
          "1",
          "3",
          "5",
          "7",
          "9",
          "11",
          "13",
          "15",
          "17",
          "19",
          "21",
          "23",
          "25",
          "27",
          "29",
          "31",
          "33",
          "35",
          "37",
          "39",
          "41",
          "43",
          "45",
          "47",
          "49",
          "51",
          "53",
          "55",
          "57",
          "59",
          "61",
          "63",
          "65",
          "67",
          "69",
          "71",
          "73",
          "75",
          "77",
          "79",
          "81",
          "83",
          "85",
          "87",
          "89",
          "91",
          "93",
          "95",
          "97",
          "99",
        ],
      },
      primesLessThan100: {
        title: "Primes < 100",
        button_text: "",
        demo: "2,3,5,7,11",
        content: [
          "2",
          "3",
          "5",
          "7",
          "11",
          "13",
          "17",
          "19",
          "23",
          "29",
          "31",
          "37",
          "41",
          "43",
          "47",
          "53",
          "59",
          "61",
          "67",
          "71",
          "73",
          "79",
          "83",
          "89",
          "97",
        ],
      },
      fibonacciFirst36: {
        title: "Fibonacci: first 36",
        button_text: "",
        demo: "0,1,1,2,3,5,8",
        content: [
          "0",
          "1",
          "1",
          "2",
          "3",
          "5",
          "8",
          "13",
          "21",
          "34",
          "55",
          "89",
          "144",
          "233",
          "377",
          "610",
          "987",
          "1597",
          "2584",
          "4181",
          "6765",
          "10946",
          "17711",
          "28657",
          "46368",
          "75025",
          "121393",
          "196418",
          "317811",
          "514229",
          "832040",
          "1346269",
          "2178309",
          "3524578",
          "5702887",
          "9227465",
        ],
      },
    },
  },
};

export const sticky_colors = [
  "gray",
  "light_yellow",
  "yellow",
  "orange",
  "light_green",
  "green",
  "dark_green",
  "cyan",
  "light_pink",
  "pink",
  "violet",
  "red",
  "light_blue",
  "blue",
  "dark_blue",
  "black",
];

export const shapes = [
  "rectangle",
  "circle",
  "triangle",
  "round_rectangle",
  "rhombus",
  "wedge_round_rectangle_callout",
  "parallelogram",
  "star",
  "right_arrow",
  "left_arrow",
  "pentagon",
  "hexagon",
  "octagon",
  "trapezoid",
  "flow_chart_predefined_process",
  "left_right_arrow",
  "cloud",
  "left_brace",
  "right_brace",
  "cross",
  "can",
];

// 100 most popular emoji
export const popularEmoji = [
  "🤣",
  "😂",
  "😉",
  "🥰",
  "😍",
  "🤩",
  "🤗",
  "🤔",
  "🥵",
  "🥳",
  "😳",
  "😢",
  "😭",
  "🤡",
  "👽",
  "🤖",
  "💓",
  "❤️",
  "🖤",
  "🤍",
  "💤",
  "👍",
  "👏",
  "💪",
  "👀",
  "👁️",
  "🤦",
  "🤷‍♂️",
  "👼",
  "🏃",
  "💃",
  "🕺",
  "💑",
  "🐈",
  "🐐",
  "🐼",
  "🐦",
  "🐢",
  "🐟",
  "🦋",
  "🌹",
  "🪴",
  "🍃",
  "🍊",
  "🍕",
  "🎂",
  "🍺",
  "🗺️",
  "🏠",
  "🏫",
  "✈️",
  "🌡️",
  "☀️",
  "⭐",
  "🔥",
  "✨",
  "🎁",
  "🎟️",
  "👓",
  "🧢",
  "💎",
  "📢",
  "📣",
  "🎶",
  "🎤",
  "🎸",
  "📱",
  "💻",
  "🖥️",
  "📺",
  "📷",
  "🔍",
  "🕯️",
  "📖",
  "📰",
  "💰",
  "📅",
  "🔨",
  "🗿",
  "⚠️",
  "🔞",
  "➡️",
  "☮️",
  "⚕️",
];
